import "../../app.css";
import Navbar from "../../components/Navbar.js";


function About() {
    return (
        <div>
            <Navbar/>
            <div className="sobreNos">
            <h1>Sobre nós</h1>
            <p>Este aplicativo foi desenvolvido no contexto do Bootcamp de Desenvelvedor Full-stack oferecido pela ENAP em parceria com a Ironhack.</p>
            <p>A equipe que desenvolveu esse projeto foi composta pelo Márcio Silva (IFCE), Karen Ortiz (TJDFT), Ana Aleixo (JFPE), Rodrigo Sotolani (JFMS) e Vitor Martins (MRE)</p>
            <p>Foi com a grande maestria e paciência da equipe de professores que este projeto saiu do papel em menos de uma semana.</p>
            <p>Não podemos deixar de mencionar o incrível prazer que foi ter a Srta. Karen Okasaki como nossa professora: além de um conhecimento enciclopédico, a sua didática e paciência são insuperáveis.</p>
            </div>
        </div>
    );
}

export default About;